// @ts-nocheck
import { ThemeTypography } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    title: string;
    eventLink?: string;
    variant?: keyof ThemeTypography;
    forwardAs?: keyof JSX.IntrinsicElements | undefined;
    lightText?: boolean;
    extendedStyles?: EventTitleStyles;
}

export interface EventTitleStyles {
    textTitle?: TypographyPresentationProps;
    linkTextTitle?: LinkPresentationProps;
}

export const eventTitleStyles: EventTitleStyles = {
    linkTextTitle: {
        css: css`
            margin-bottom: ${pxToRem(5)};
        `,
    },
};

const EventTitle = ({ title, eventLink, variant, forwardAs, lightText, extendedStyles }: Props) => {
    const styles = useMergeProps(eventTitleStyles, extendedStyles);

    const renderText = () => (
        <Typography
            {...styles.textTitle}
            color={lightText ? "white" : "primary"}
            variant={variant ?? "h3"}
            forwardAs={forwardAs ?? "h2"}
        >
            {title}
        </Typography>
    );

    return eventLink ? (
        <Link href={eventLink} {...styles.linkTextTitle}>
            {renderText()}
        </Link>
    ) : (
        renderText()
    );
};

export default EventTitle;
